import axios from "axios";
import store from "..";
import { languageHelper } from "../../helpers";

const state = {
  loadedItems: {
    images: false,
    fonts: false,
  },
  screenWidth: window.innerWidth,
  isMobile: window.innerWidth <= 768,
  modalData: null,
  locale: "en",
  autoDarkMode: true,
  darkMode: false,
};

const getters = {
  getUserInfo: (state) => state.userInfo,
};

const actions = {
  async setLoadedItem({ commit }, payload) {
    commit("setLoadedItem", payload);
  },
  async setScreenWidth({ commit }, payload) {
    commit("setScreenWidth", payload);
  },
  async setIsMobile({ commit }, payload) {
    commit("setIsMobile", payload);
  },

  async setAutoDarkMode({ commit }, payload) {
    if (payload === null) return;
    try {
      localStorage.setItem("gd-autodarkmode", payload);
      if (payload && (payload === true || payload === "true")) {
        store.dispatch(
          "setDarkMode",
          window.matchMedia &&
            window.matchMedia("(prefers-color-scheme: dark)").matches
        );
      }
    } catch (err) {
      console.log("err saving localstorage", err);
    }
    commit("setAutoDarkMode", payload === true || payload === "true");
  },
  async setDarkMode({ commit }, payload) {
    if (payload === null) return;
    try {
      localStorage.setItem("gd-darkmode", payload);
    } catch (err) {
      console.log("err saving localstorage");
    }
    commit("setDarkMode", payload === true || payload === "true");
  },
  async setLocale({ commit }, payload) {
    if (payload === null) return;
    try {
      localStorage.setItem("gd-locale", payload);
    } catch (err) {
      console.log("err saving localstorage");
    }
    if (state.currentLangKey === payload) return;
    languageHelper.setI18nConfig(payload);
    commit("setLocale", payload);
  },
  async setModalData({ commit }, payload) {
    document.documentElement.style.overflow =
      payload === null ? "auto" : "hidden";
    commit("setModalData", payload);
  },
};

const mutations = {
  setLoadedItem: (state, payload) => {
    state.loadedItems = {
      ...state.loadedItems,
      [payload.loadedProperty]: payload.isLoaded,
    };
  },
  setScreenWidth: (state, payload) => {
    state.screenWidth = payload;
  },
  setIsMobile: (state, payload) => {
    state.isMobile = payload;
  },
  setModalData: (state, payload) => {
    state.modalData = payload;
  },
  setDarkMode: (state, payload) => {
    state.darkMode = payload;
  },
  setAutoDarkMode: (state, payload) => {
    state.autoDarkMode = payload;
  },
  setLocale: (state, payload) => {
    state.locale = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
